import { BaseMethod } from "./_Base";
export class ArgExpression extends BaseMethod {
  constructor() {
    super(...arguments);
    this._requireDependency = true;
  }
  static requiredArguments() {
    return [
      ["string", "arguments list"],
      ["number", "index"]
    ];
  }
  processArguments(args) {
    return new Promise((resolve, reject) => {
      if (args.length == 2) {
        const argumentsList = args[0];
        const index = args[1];
        const val = argumentsList.split(" ")[index];
        resolve(val);
      } else {
        resolve(0);
      }
    });
  }
}
